<template>
  <div class="wrapper-inside">
    <b-card>
      <div v-if="loading">
        {{ $t('generic.loading', 'Loading') }}...
      </div>
      <div v-if="!loading && error != ''">
        {{ error }} {{ $t('generic.try-again', 'Please try again') }}.
      </div>
      <b-table
        v-if="!loading && error === ''"
        striped
        hover
        :items="finalPermissions"
        :fields="fields"
      >
        <template
          slot="actions"
          slot-scope="data"
        >
          <b-form-checkbox
            v-model="data.item.has"
            name="check-button"
            switch
            @change="togglePermission(data.item)"
          />
        </template>
      </b-table>
    </b-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: true,
      error: '',
      allPermissions: '',
      userPermissions: '',
      finalPermissions: [],
      roleId: ''
    }
  },
  computed: {
    fields() {
      return [
        {
          key: 'id',
        },
        {
          key: 'name',
          label: this.$t('pages.admin.permissions.permission', 'Permission')
        },
        {
          key: 'actions',
          label: this.$t('pages.admin.permissions.assign', 'Assign')
        }
      ];
    }
  },
  async mounted() {
    // CHECK FOR PERMISSIONS
    if(!this.$can('permissions_manage') && !this.$hasRole(['super-admin'])) {
      this.$router.push({ name: 'not-found' });
      return;
    }
    // ---

    this.roleId = this.$route.params.id;

    await this.axios
      .get('/roles/permissions')
      .then( response => this.allPermissions = response.data )
      .catch( (error) => {
        this.error = error.response.data.error;
      });

    await this.axios
      .get('/roles/permissions/' + this.roleId)
      .then( response => this.userPermissions = response.data )
      .catch( (error) => {
        this.error = error.response.data.error;
      });

    await this.buildPermissionsMap();

    this.loading = false;
    if(this.allPermissions === '' && !this.error) {
      this.error = this.$t('pages.admin.permissions.no-permissions', 'No permissions yet!');
    }
  },
  methods: {
    buildPermissionsMap() {
      for(let permission of this.allPermissions) {
        this.finalPermissions.push( { id: permission.id, name: permission.name, has: false} );
      }
      for(let userPermission of this.userPermissions) {
        for(let finalPermmission of this.finalPermissions) {
          if(userPermission.id === finalPermmission.id && userPermission.name === finalPermmission.name) {
            finalPermmission.has = true;
          }
        }
      }
    },
    async togglePermission(item) {
      if(item.has) {
        // Turn off
        await this.axios
          .post('/roles/permissions/' + this.roleId + '/unassign', item)
          .then( () => {
            item.has = false;
            this.$toastNotification('success', '', this.$t('pages.admin.permissions.unassign.success', 'Unassigned successfully'));
          })
          .catch( (error) => {
            item.has = true;
            this.$toastNotification('danger', '', error.response.data.error);
          });
      } else {
        // Turn on
        await this.axios
          .post('/roles/permissions/' + this.roleId + '/assign', item)
          .then( () => {
            item.has = true;
            this.$toastNotification('success', '', this.$t('pages.admin.permissions.assign.success', 'Assigned successfully'));
          })
          .catch( (error) => {
            item.has = false;
            this.$toastNotification('danger', '', error.response.data.error);
          });
      }
    }
  }
}
</script>
